import { action, observable } from 'mobx';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';
import { RoadmapResponseDto, ReleaseNoteDto } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';
import MessageCenter from '../MessageCenter/MessageCenterVM';
interface IReleaseNotes {
  createdBy: string;
  creationDateUtc: number;
  deleted: boolean;
  lastChangeDateUtc: number;
  lastChangedBy: string;
  releaseDate: string;
  releaseDescription: string;
  releaseId: number;
  releaseTitle: string;
  releaseVersion: string;
}
type Dictionary<T> = {
  [key: string]: T;
};

export class AboutPageVM {
  @observable loader: boolean = false;
  @observable releaseNotes: IReleaseNotes[] = [];
  @observable releaseNotesDictionary: Dictionary<IReleaseNotes> = {};
  @observable Roadmap: RoadmapResponseDto[] = [];
  @observable roadmapDescription: string = '';
  @observable mode: 'add' | 'edit' | 'delete' | 'original' | 'deletePopup' | 'editPopup' = 'original';
  @observable releaseNumber: string = '';
  @observable releaseDate: string = '';
  @observable addedReleaseNoteName: string = '';
  @observable rteReleaseNoteDescription: string = '';
  @observable selectedReleaseNote;
  @observable seletedDeletetReleaseNotes: number[] = [];
  @observable releaseNoteInputsValidation = {
    releaseVersion: {
      valid: false,
      errorMessage: ''
    },
    releaseDate: {
      valid: false,
      errorMessage: ''
    },
    title: {
      valid: false,
      errorMessage: ''
    },
    description: {
      valid: false,
      errorMessage: ''
    }
  }
  @observable disableSaveButtonAddNote = true;

  @action.bound onChangeReleaseNumber(event) {
    const { name, value } = event.target;
    this.releaseNumber = value;
  }
  @action.bound onChangeReleaseDate(event) {
    const { name, value } = event.target;
    this.releaseDate = value;
  }
  @action.bound onChangeAddedReleaseNoteName(event) {
    const { name, value } = event.target;
    this.addedReleaseNoteName = value;
  }

  @action.bound rteTextCallBack(content: string) {
    this.rteReleaseNoteDescription = content;
  }

  @action.bound onChangeCheckDeleteReleaseNotes(id: number) {
    if (this.seletedDeletetReleaseNotes.includes(id)) {
        this.seletedDeletetReleaseNotes.splice(this.seletedDeletetReleaseNotes.indexOf(id), 1)
    }
    else {
        this.seletedDeletetReleaseNotes.push(id)
    }
}

  validateVersionNumber(value: string | undefined): boolean {
    if (value === undefined) {
      return false;
    }
    if (value.match(/^(\d+\.\d+\.\d+)(\.\d+)?$/g)) {
      return true;
    }
    else {
      return false;
    }
  }
  @action.bound releaseNoteValidateInputs(e) {
    const { name, value } = e.target;
    if (name === 'release-version') {
      if (value === '' || value === undefined || !this.validateVersionNumber(value)) {
        this.releaseNoteInputsValidation.releaseVersion.valid = false;
        this.releaseNoteInputsValidation.releaseVersion.errorMessage = 'Input must not be empty.'
      }
      else {
        this.releaseNoteInputsValidation.releaseVersion.valid = true;
        this.releaseNoteInputsValidation.releaseVersion.errorMessage = '';
      }
    }
    else if (name === 'release-date') {
      if (value === '' || value === undefined) {
        this.releaseNoteInputsValidation.releaseDate.valid = false;
        this.releaseNoteInputsValidation.releaseDate.errorMessage = 'Input must not be empty.';

      }
      else {
        this.releaseNoteInputsValidation.releaseDate.valid = true;
        this.releaseNoteInputsValidation.releaseDate.errorMessage = '';
      }
    }
    else if (name === 'note-title') {
      if (value === '' || value === undefined) {
        this.releaseNoteInputsValidation.title.valid = false;
        this.releaseNoteInputsValidation.title.errorMessage = 'Input must not be empty.';
      }
      else {
        this.releaseNoteInputsValidation.title.valid = true;
        this.releaseNoteInputsValidation.title.errorMessage = '';
      }
    }
    // RTE
    else if (name === undefined) {
      if (this.rteReleaseNoteDescription.length === 0) {
        this.releaseNoteInputsValidation.description.valid = false;
        this.releaseNoteInputsValidation.description.errorMessage = 'Input must not be empty.';
        this.handleChangeBorderColor('red');
      }
      else {
        this.releaseNoteInputsValidation.description.valid = true;
        this.releaseNoteInputsValidation.description.errorMessage = '';
        this.handleChangeBorderColor('');
      }
    }
    this.saveButtonAddReleaseNoteControl();
  }
  saveButtonAddReleaseNoteControl() {
    if (this.releaseNoteInputsValidation.releaseVersion.valid && this.releaseNoteInputsValidation.releaseDate.valid && this.releaseNoteInputsValidation.title.valid && this.releaseNoteInputsValidation.description.valid === true) {
      this.disableSaveButtonAddNote = false;
    }
    else {
      this.disableSaveButtonAddNote = true;
    }
  }
  // tox-tinymce
  handleChangeBorderColor(color?) {
    const editorContainer = document.querySelector('.tox-tinymce') as HTMLElement;
    if (editorContainer) {
      if (color === 'red') {
        editorContainer.style.borderColor = '#cd2026';
        editorContainer.style.borderWidth = '0.25rem';
        editorContainer.style.borderStyle = 'solid';
      }
      else {
        editorContainer.style.borderColor = '';
        editorContainer.style.borderWidth = '';
        editorContainer.style.borderStyle = '';
      }
    }
  }
  resetAddReleaseNote() {
    this.releaseNumber = '';
    this.releaseDate = '';
    this.addedReleaseNoteName = '';
    this.rteReleaseNoteDescription = '';
    this.selectedReleaseNote = undefined;
    this.releaseNoteInputsValidation = {
      releaseVersion: {
        valid: false,
        errorMessage: ''
      },
      releaseDate: {
        valid: false,
        errorMessage: ''
      },
      title: {
        valid: false,
        errorMessage: ''
      },
      description: {
        valid: false,
        errorMessage: ''
      }
    }
    this.saveButtonAddReleaseNoteControl();
  }

  @action.bound handleReleaseNoteCancel() {
    this.switchMode('original');
    this.resetAddReleaseNote();
    this.seletedDeletetReleaseNotes = [];
  }

  @action.bound async getReleaseNotes() {
    try {
      const response: any = await PRJAPI.ReleaseNotesController.getAllUsingGET();
      if (response.data.length > 0) {
        this.releaseNotes = response.data.sort((a, b) => {
          return Date.parse(b.releaseDate) - Date.parse(a.releaseDate);
        });
        response.data.forEach(e => { this.releaseNotesDictionary[e.releaseId] = e });
      }
    } catch (error) {
      console.error('getReleaseNotes error:', error);
    }
  }

  @action.bound async getRoadmap() {
    try {
      const response: any = await PRJAPI.RoadmapController.getAllRoadmapsUsingGET();
      if (response.data.length > 0) {
        this.Roadmap = response.data;
        this.roadmapDescription = response.data[0]['roadmapDescription'];
      }
    } catch (error) {
      console.error('getRoadmap error:', error);
    }
  }
  @action.bound switchMode(mode: 'add' | 'edit' | 'delete' | 'original' | 'deletePopup' | 'editPopup') {
    if(mode === 'delete' && this.mode === 'delete'){
      this.mode = 'original';
      this.seletedDeletetReleaseNotes = [];
      return
    }
    else if(mode === 'deletePopup' && this.mode === 'deletePopup'){
      this.mode = 'delete';
      return 
    }
    else if(mode === 'editPopup' && this.mode === 'editPopup'){
      this.seletedDeletetReleaseNotes = [];
      this.mode = 'edit';
      return 
    }
    else if(mode === 'delete' && this.mode === 'edit'){
      this.seletedDeletetReleaseNotes = [this.selectedReleaseNote.releaseId]
      this.mode = 'editPopup';
      return
    }
    this.mode = mode;
  }

  @action.bound async onClickSaveReleaseNote() {
    this.disableSaveButtonAddNote = true;
    if (this.mode === 'add') {
      try {
        const requestPayload: ReleaseNoteDto = {
          createdBy: localStorage['username'],
          lastChangedBy: localStorage['username'],
          releaseTitle: this.addedReleaseNoteName,
          releaseDescription: this.rteReleaseNoteDescription,
          releaseVersion: this.releaseNumber,
          deleted: false,
          releaseDate: this.releaseDate
        }
        await PRJAPI.ReleaseNotesController.createNewReleaseNoteUsingPOST(requestPayload);
        await this.getReleaseNotes();
        this.resetAddReleaseNote();
        this.switchMode('original');
      } catch (error) {
        console.error('addNotes error:', error);
        this.saveButtonAddReleaseNoteControl();
      }
    }
    else if (this.mode === 'edit') {
      try {
        const requestPayload: ReleaseNoteDto = {
          createdBy: this.selectedReleaseNote.createdBy,
          lastChangedBy: localStorage['username'],
          releaseTitle: this.addedReleaseNoteName,
          releaseDescription: this.rteReleaseNoteDescription,
          releaseVersion: this.releaseNumber,
          deleted: false,
          releaseDate: this.releaseDate
        }
        await PRJAPI.ReleaseNotesController.updateReleaseNoteUsingPOST(this.selectedReleaseNote.releaseId, requestPayload);
        await this.getReleaseNotes();
        this.resetAddReleaseNote();
        this.switchMode('original');
      } catch (error) {
        console.error('update notes error', error)
        this.saveButtonAddReleaseNoteControl();
      }
    }
    this.disableSaveButtonAddNote = false;
  }

  @action.bound onClickEditReleaseNote(index) {
    this.selectedReleaseNote = this.releaseNotes[index];
    this.releaseNumber = this.selectedReleaseNote.releaseVersion;
    this.releaseDate = this.selectedReleaseNote.releaseDate ? new Date(this.selectedReleaseNote.releaseDate).toISOString().split('T')[0] : this.selectedReleaseNote.releaseDate;
    this.addedReleaseNoteName = this.selectedReleaseNote.releaseTitle;
    this.rteReleaseNoteDescription = this.selectedReleaseNote.releaseDescription;
    this.switchMode('edit');
    this.validateExistingForm();
  }

  @action.bound async deleteReleaseNoteHandler(){
    this.loader = true;
    try {
      for( const id of this.seletedDeletetReleaseNotes){
        await PRJAPI.ReleaseNotesController.deleteReleaseNoteByIdUsingDELETE(id);
    }
    } catch (error) {
      console.error('getRoadmap error:', error);
    }
    await this.getReleaseNotes()
    this.switchMode('original');
    this.resetAddReleaseNote();
    this.seletedDeletetReleaseNotes = [];
    this.loader = false;
  }

  @action.bound validateExistingForm(): boolean {
    this.releaseNoteValidateInputs({ target: { name: 'release-version', value: this.releaseNumber } })
    this.releaseNoteValidateInputs({ target: { name: 'release-date', value: this.releaseDate } })
    this.releaseNoteValidateInputs({ target: { name: 'note-title', value: this.addedReleaseNoteName } })
    this.releaseNoteValidateInputs({ target: { name: undefined, value: this.rteReleaseNoteDescription } })
    this.saveButtonAddReleaseNoteControl();
    if (this.disableSaveButtonAddNote) {
      return true; // invalid form
    }
    else {
      return false; // valid form
    }
  }
}
